import * as v from 'valibot';
import Ajax from '../util/ajax';
import { bindingTableSchema } from '../types/Zigbee/BindingTable';
import { zigbeeNodeBindingTableUpdated } from '../features/zigbee_node_binding_table/zigbeeNodeBindingTableSlice';
export function fetchZigbeeBindingTable(zigbee_node_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/bindingtable';
        ajax.get(url, undefined, data => {
            const res = v.safeParse(bindingTableSchema, data);
            if (res.success) {
                const bt = res.output;
                dispatch(zigbeeNodeBindingTableUpdated({ node_id: zigbee_node_id, binding_table: bt }));
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
